export type Entries<T> = { [K in keyof T]: [K, T[K]]; }[keyof T][];

/** Create a new type that adds a prefix to all values of an existing string literal union type, */
export type Prefix<Prefix extends string, T extends string> = `${Prefix}${T}`;

/**
 * The opposite of the built-in `Exclude` utility type: Constructs a type from members of `UnionType` that are assignable to `IncludedMembers`.
 *
 * @see [The `Exclude` utility type](https://www.typescriptlang.org/docs/handbook/utility-types.html#excludeuniontype-excludedmembers)
 */
export type Include<UnionType, IncludedMembers extends UnionType> = IncludedMembers;

/** The opposite of the built-in `NonNullable` utility type. */
export type Nullable<T> = T | null | undefined;

export function entries<O extends object> (object: O) {
  return Object.entries(object) as Entries<O>;
}

export function keys<O extends object> (object: O) {
  return Object.keys(object) as (keyof O)[];
}
